import { render, staticRenderFns } from "./PeerServices.vue?vue&type=template&id=6f3a42ae&"
import script from "./PeerServices.vue?vue&type=script&lang=js&"
export * from "./PeerServices.vue?vue&type=script&lang=js&"
import style0 from "./PeerServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PeerServices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports